/**
 * All amounts are integers in centimes (1 MAD = 100 centimes) to avoid
 * floating point errors. Formatting is the only place where they become text.
 */
export type Locale = "fr" | "ar";

export function formatMAD(cents: number, locale: Locale = "fr"): string {
  const hasDecimals = cents % 100 !== 0;
  const amount = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  })
    .format(cents / 100)
    .replace(/ | /g, " ");
  return locale === "ar" ? `${amount} د.م.` : `${amount} DH`;
}

/** Parses a user-typed amount ("12,5", "12.50", "12") into centimes. */
export function parseMADToCents(input: string | number): number | null {
  const s = String(input).trim().replace(",", ".").replace(/\s/g, "");
  if (!/^\d{1,7}(\.\d{1,2})?$/.test(s)) return null;
  return Math.round(Number(s) * 100);
}

/** 1250 -> "12.5", 1200 -> "12" (for number inputs). */
export function centsToInput(cents: number): string {
  return String(cents / 100);
}
